module.exports = __webpack_public_path__ + "static/media/birthday-party-banner.b526fc27.jpg";